import React from 'react';
import { 
  HelpCircle, 
  Clock, 
  Percent, 
  PiggyBank, 
  TrendingUp,
  BarChart2,
  ShieldCheck,
  Briefcase
} from 'lucide-react';

const TipsSidebar = () => {
  const tips = [
    {
      icon: PiggyBank,
      title: 'Регулярные взносы',
      description: 'Регулярные пополнения счета значительно увеличивают итоговую доходность за счет сложного процента.'
    },
    {
      icon: Clock,
      title: 'Долгосрочный горизонт',
      description: 'Чем дольше срок инвестирования, тем сильнее проявляется эффект сложных процентов.'
    },
    {
      icon: Percent,
      title: 'Процентная ставка',
      description: 'Даже небольшое повышение годовой ставки значительно увеличивает итоговую сумму при длительном сроке.'
    },
    {
      icon: TrendingUp,
      title: 'Капитализация',
      description: 'Чем чаще происходит капитализация, тем выше итоговая доходность вложений.'
    },
    {
      icon: BarChart2,
      title: 'Диверсификация',
      description: 'Распределяйте средства между разными классами активов для снижения рисков.'
    },
    {
      icon: ShieldCheck,
      title: 'Налоговые льготы',
      description: 'Используйте индивидуальные инвестиционные счета (ИИС) для получения налоговых вычетов.'
    },
    {
      icon: Briefcase,
      title: 'Раннее начало',
      description: 'Чем раньше вы начнете инвестировать, тем больший капитал накопите благодаря силе сложных процентов.'
    }
  ];

  return (
    <div className="bg-white dark:bg-gray-800 rounded-xl border border-gray-200 dark:border-gray-700 p-5 shadow-sm">
      <h3 className="text-lg font-medium text-gray-900 dark:text-white mb-4 flex items-center">
        <HelpCircle className="w-5 h-5 mr-2 text-indigo-500" />
        Советы инвестора
      </h3>

      <div className="space-y-3">
        {tips.map((tip, index) => (
          <div 
            key={index} 
            className="flex items-start space-x-3 p-3 bg-gray-50 dark:bg-gray-700/30 rounded-lg border border-gray-200 dark:border-gray-700 hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors"
          >
            <tip.icon className="w-5 h-5 text-indigo-500 mt-1 flex-shrink-0" />
            <div>
              <h4 className="text-sm font-medium text-gray-900 dark:text-white mb-1">
                {tip.title}
              </h4>
              <p className="text-xs text-gray-600 dark:text-gray-400">
                {tip.description}
              </p>
            </div>
          </div>
        ))}
      </div>

      <div className="mt-6 p-4 bg-green-50 dark:bg-green-900/20 border border-green-100 dark:border-green-800 rounded-lg">
        <div className="flex items-start space-x-3">
          <PiggyBank className="w-5 h-5 text-green-500 mt-1 flex-shrink-0" />
          <div>
            <h4 className="text-sm font-semibold text-green-700 dark:text-green-300 mb-2">
              Правило 72
            </h4>
            <p className="text-xs text-green-600 dark:text-green-400 mb-3">
              Чтобы примерно узнать, за сколько лет ваши деньги удвоятся, разделите число 72 на годовую процентную ставку. 
              Например, при ставке 8% годовых сумма удвоится примерно за 72/8 = 9 лет.
            </p>
            <div className="text-xs font-medium text-green-700 dark:text-green-300 px-3 py-2 bg-green-100 dark:bg-green-800/50 rounded-lg">
              Секрет успешного инвестирования — время, а не выбор момента входа на рынок.
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TipsSidebar;